import type { InvoiceSearchV2Filters, InvoiceSearchV2Request } from '../Types/invoiceSearchV2Types';

interface InvoiceSearchPagination {
  page: number;
  pageSize: number;
}

const normalizeTextFilter = (value: string | undefined | null): string | undefined => {
  if (value == null) return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const parseOptionalPositiveFloat = (value: string | undefined | null): number | undefined => {
  if (value == null) return undefined;
  const trimmed = value.trim();
  if (trimmed.length === 0) return undefined;
  if (!/^\d+(?:[.,]\d+)?$/.test(trimmed)) return undefined;
  const parsed = Number(trimmed.replace(',', '.'));
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : undefined;
};

export const mapInvoiceSearchFiltersToRequest = (
  filters: InvoiceSearchV2Filters,
  pagination: InvoiceSearchPagination
): InvoiceSearchV2Request => {
  const pageNumber = Math.max(pagination.page + 1, 1);
  const searchTerm = normalizeTextFilter(filters.searchTerm);
  const invoiceNumber = normalizeTextFilter(filters.invoiceNumber);
  const issueDateFrom = filters.issueDateFrom || undefined;
  const issueDateTo = filters.issueDateTo || undefined;
  const totalAmountFrom = parseOptionalPositiveFloat(filters.totalAmountFrom);
  const totalAmountTo = parseOptionalPositiveFloat(filters.totalAmountTo);
  const buyerName = normalizeTextFilter(filters.buyerName);
  const buyerAddress = normalizeTextFilter(filters.buyerAddress);
  const recipientName = normalizeTextFilter(filters.recipientName);
  const type = filters.type || undefined;
  const status = filters.status || undefined;

  return {
    ...(searchTerm !== undefined && { searchTerm }),
    ...(invoiceNumber !== undefined && { invoiceNumber }),
    ...(issueDateFrom !== undefined && { issueDateFrom }),
    ...(issueDateTo !== undefined && { issueDateTo }),
    ...(totalAmountFrom !== undefined && { totalAmountFrom }),
    ...(totalAmountTo !== undefined && { totalAmountTo }),
    ...(buyerName !== undefined && { buyer: buyerName }),
    ...(buyerAddress !== undefined && { buyerAddress }),
    ...(recipientName !== undefined && { recipientName }),
    ...(type !== undefined && { type }),
    ...(status !== undefined && { status }),
    pageNumber,
    pageSize: pagination.pageSize,
  };
};
